module.exports = __webpack_public_path__ + "static/img/12573.36e13fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/12573.jpg
// module id = FNNk
// module chunks = 1